import { createContext, memo, useContext, type ComponentType } from "react";

export const ShippingNewSettingsContext = createContext(false);

export function useShippingNewSettings(): boolean {
  return useContext(ShippingNewSettingsContext);
}

export function withShippingNewSettings<Props extends object>(
  NewComponent: ComponentType<Props>,
  LegacyComponent: ComponentType<Props>,
) {
  return memo(function ShippingSettingsVariant(props: Props) {
    const enabled = useShippingNewSettings();
    const Component = enabled ? NewComponent : LegacyComponent;
    return <Component {...props} />;
  });
}
